import React, { useState } from 'react';

const HakedisFaturaModal = ({ hakedis, onClose, onSubmit, isSubmitting = false }) => {
  const [faturaNumarasi, setFaturaNumarasi] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = () => {
    const trimmed = String(faturaNumarasi || '').trim();
    if (!trimmed) {
      setError('Fatura numarası gereklidir');
      return;
    }
    setError('');
    onSubmit(trimmed);
  };

  if (!hakedis) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '400px' }}>
        <div className="modal-header">
          <h2>Fatura Bilgisi Ekle</h2>
          <button type="button" className="modal-close-btn" onClick={onClose} aria-label="Kapat">
            <i className="fas fa-times"></i>
          </button>
        </div>
        <div className="modal-body">
          <p style={{ marginBottom: 16, fontSize: 13, color: 'var(--text-gray)' }}>
            Randevu {hakedis.randevuNumarasi || '—'} için fatura numarasını girin.
          </p>
          <div style={{ marginBottom: 12 }}>
            <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>Fatura Numarası *</label>
            <input
              type="text"
              value={faturaNumarasi}
              onChange={(e) => setFaturaNumarasi(e.target.value)}
              placeholder="Fatura no"
              maxLength={100}
              style={{ width: '100%', padding: '8px 12px', border: '1px solid var(--border-color)', borderRadius: 6 }}
            />
          </div>
          {error && <div style={{ color: 'var(--error)', marginTop: 8, fontSize: 13 }}>{error}</div>}
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onClose}>İptal</button>
          <button type="button" className="btn btn-primary" onClick={handleSubmit} disabled={isSubmitting}>
            {isSubmitting ? 'Kaydediliyor...' : 'Kaydet'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HakedisFaturaModal;
